module.exports = {
  name: 'menu-tabs',
  settings: {
    infinite: false,
    slidesToShow: 6,
    dots: false,
    arrows: true,
    variableWidth: true,
    draggable: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 'lg',
        settings: {
          slidesToShow: 5,
          arrows: false,
        }
      },
      {
        breakpoint: 'md',
        settings: {
          slidesToShow: 3,
          arrows: false,
        }
      },
      {
        breakpoint: 'sm',
        settings: {
          slidesToShow: 2,
          arrows: false,
        }
      },
    ]
  },
}
